import { useQuery } from '@tanstack/react-query';
import invariant from 'tiny-invariant';

import { ShortUrl } from '@air/api';

const getPublicCitiesListKey = ({
  shortId,
  search,
  boardId,
}: {
  shortId: string | undefined;
  search: string;
  boardId: string | undefined;
}) => ['PUBLIC_CITIES', { shortId, search, boardId }];

export const usePublicCitiesList = ({
  search,
  shortId,
  boardId,
}: {
  search: string;
  shortId: string;
  boardId: string | undefined;
}) => {
  const key = getPublicCitiesListKey({ shortId, search, boardId });

  return useQuery({
    queryKey: key,

    queryFn: async () => {
      invariant(shortId, 'Short ID is required');

      const data = await ShortUrl.getAssetVersionFilterLookups({
        limit: 20,
        shortId,
        descendantBoardId: boardId,
        field: 'location.city',
        search,
      });

      return data.lookups.map(({ value }) => value.toString());
    },
    enabled: !!shortId,
  });
};
